import { render, staticRenderFns } from "./RequestMatchingWarningNewComment.vue?vue&type=template&id=5dfff31c&"
import script from "./RequestMatchingWarningNewComment.vue?vue&type=script&lang=js&"
export * from "./RequestMatchingWarningNewComment.vue?vue&type=script&lang=js&"
import style0 from "./RequestMatchingWarningNewComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VToolbar})
